export default __webpack_public_path__ + "static/media/brand_id_1.a5ae40c7.jpg";